import React from 'react';
import { motion } from 'framer-motion';

const What = () => {
  const reviews = [
    { name: "Emily R", loc: "USA", img: "https://randomuser.me/api/portraits/women/1.jpg", text: "This platform changed the way I stay in touch with my friends and family. The interface is smooth!" },
    { name: "Amit K", loc: "India", img: "https://randomuser.me/api/portraits/men/2.jpg", text: "Finally, a social network that understands what I need! The privacy features are a game-changer." },
    { name: "Sophie M", loc: "UK", img: "https://randomuser.me/api/portraits/women/3.jpg", text: "I joined just to explore, but now I can't imagine my day without it. Real-time chat is amazing!" },
    { name: "Javier L", loc: "Spain", img: "https://randomuser.me/api/portraits/men/4.jpg", text: "Running my small business has never been easier! This platform helped me connect with customers." },
    { name: "Lucas T", loc: "Brazil", img: "https://randomuser.me/api/portraits/men/5.jpg", text: "The perfect blend of fun and functionality! Discovering trending content is so easy." },
    { name: "Nora S", loc: "Canada", img: "https://randomuser.me/api/portraits/women/6.jpg", text: "I've tried many social platforms, but this one truly stands out! Every feature just makes sense." },
    { name: "Sarah W", loc: "Australia", img: "https://randomuser.me/api/portraits/women/7.jpg", text: "Love the community vibe here. It's much more positive than other social apps." },
    { name: "Liam O", loc: "Ireland", img: "https://randomuser.me/api/portraits/men/8.jpg", text: "The user experience is top-notch. Everything is fast and very intuitive to use." },
    { name: "Chen Y", loc: "China", img: "https://randomuser.me/api/portraits/women/9.jpg", text: "A great place to meet new people with similar interests. Highly recommended!" }
  ];

  return (
    <section className="bg-bggraycolor py-16 lg:py-24 px-6 relative font-avant overflow-hidden">
      <div className="container mx-auto max-w-7xl">
        
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold text-zinc-900 tracking-tight"
          >
            What Our Users Say
          </motion.h2>
        </div>

        <div className="relative">
          {/* Grid Layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {reviews.map((review, index) => {
              
              // Mobile Logic: Sirf pehle 3 cards dikhao
              // Desktop Logic: Saare dikhao lekin index 7 (center bottom) ko hide karo
              const isHiddenOnMobile = index >= 3; 
              const isLastRowSide = index === 6 || index === 8;
              const isLastRowCenter = index === 7;

              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: (index % 3) * 0.1, duration: 0.5 }}
                  // Mobile par 3 ke baad wale cards hide, Desktop par logic apply
                  className={`bg-bggraycolor p-8 rounded-[2.5rem] border  
                    shadow-[inset_0_2px_2px_rgba(255,255,255,0.8),_5px_5px_15px_rgba(255,255,255,1),5px_5px_10px_rgba(0,0,0,0.3)]
            transition-all duration-500
                    ${isHiddenOnMobile ? 'hidden lg:block' : 'block'}
                    ${isLastRowSide ? 'lg:opacity-20 lg:blur-[4px] lg:pointer-events-none' : ''}
                    ${isLastRowCenter ? 'lg:invisible lg:opacity-0' : 'hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)] hover:-translate-y-2'}
                  `}
                >
                  <div className="flex gap-1 mb-4 text-yellow-400">
                    {[...Array(5)].map((_, i) => <span key={i}>★</span>)}
                  </div>

                  <p className="text-zinc-600 leading-relaxed mb-8 font-medium italic">
                    "{review.text}"
                  </p>

                  <div className="flex items-center gap-4 border-t border-zinc-50 pt-5">
                    <img src={review.img} alt={review.name} className="w-12 h-12 rounded-full object-cover shadow-sm" />
                    <div>
                      <h4 className="font-bold text-zinc-800 leading-none mb-1">{review.name}</h4>
                      <p className="text-zinc-400 text-xs font-semibold uppercase tracking-widest">{review.loc}</p>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>

          {/* Gradient Overlay for Desktop only */}
          <div className="hidden lg:block absolute bottom-0 left-0 w-full h-40  pointer-events-none z-20"></div>

          {/* See More Button */}
          <div className="mt-12 lg:absolute lg:bottom-10 lg:left-0 w-full flex justify-center z-30">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-bgcolor font-bold text-lg px-12 py-3 rounded-2xl shadow-[0_15px_40px_rgba(0,0,0,0.1)] border border-zinc-100 hover:bg-bgcolor hover:text-white transition-all"
            >
              See More
            </motion.button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default What;